import miniToastr from 'mini-toastr'
import i18n from '@/i18n'

export default {
  init () {
    // If using mini-toastr, provide additional configuration
    const toastTypes = {
      success: 'success',
      error: 'error',
      info: 'info',
      warn: 'warn'
    }

    miniToastr.init({ types: toastTypes, timeout: 5000 })
  },

  info (key: string, defaultMessage?: string) {
    miniToastr.info(i18n.message(key, defaultMessage))
  },
  success (key: string, defaultMessage?: string) {
    miniToastr.success(i18n.message(key, defaultMessage))
  },
  error (key: string, args?: any, defaultMessage?: string) {
    miniToastr.error(i18n.message(key, args, defaultMessage))
  }
}
